
import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationStart, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from 'src/environments/environment';
// Services
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from '../../services/api/message.service';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { CommonService } from 'src/app/services/api/common.service';
import { Subscription } from 'rxjs';
import Intercom from '@intercom/messenger-js-sdk';
import { MixpanelService } from 'src/app/mixpanel.service';
import { SwichBackToPythonComponent } from '../swich-back-to-python/swich-back-to-python.component';
import { NgClass, NgIf } from '@angular/common';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { BrazeService } from 'src/app/braze.service';
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DirectivesModule } from 'src/app/directives.module';
import { co } from '@fullcalendar/core/internal-common';
declare var Canny: any; // Add this at the top of your TS file
declare var $: any;
import { distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-consumer-header',
  templateUrl: './consumer-header.component.html',
  styleUrls: ['./consumer-header.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, RouterLink, RouterLinkActive, DirectivesModule, CommonAnnouncementComponent],
})
export class ConsumerHeaderComponent implements OnInit {
  @Input() announcementData = '';
  public schoolProps!: SchoolData;
  schoolLogo: any;
  activeSchoolDropdown = false;
  bookingsStatus: boolean = true;
  offcanvasOpen: boolean = false;
  sub!: Subscription;
  jobsUrl!: string;
  from_page_cookie: any;
  teacherName: any;
  jobSchoolUrl: boolean = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private brazeService: BrazeService,
    private ProfileService: ProfileService,
    private ngxService: NgxUiLoaderService,
    private sharedService: SharedService,
    private cdRef: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.schoolProps = JSON.parse(localStorage.getItem("userData") || '{}');
    $('head').append(
      '<div data-tf-live="01KP7T4APB1R623DC0FH4076K3"></div><script src="//embed.typeform.com/next/embed.js"></script>'
    );

    Canny('initChangelog', {
      appID: '68de4a8304887f1960a022d7',
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Teacher

      position: 'bottom',
      align: 'right',
      theme: 'light', // options: light [default], dark, auto
    });
    Canny('renderChangelog', {
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Teacher
      theme: 'light'
    });
    this.intercomValues();

    this.schoolLogo = this.schoolProps.properties.profile_image;
    this.bookingsStatus = this.schoolProps.properties.using_cc_to_B;
    this.from_page_cookie =
      document.cookie.match('(^|;)\\s*' + 'from' + '\\s*=\\s*([^;]+)')?.pop() ||
      '';
    this.brazeService.initializeBraze(this.schoolProps);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.checkSchoolDropdownActive(event.url);
      }
    });
    this.checkSchoolDropdownActive(this.router.url);
    // this.ProfileService.bookingsStatus$
    //   .pipe(distinctUntilChanged())
    //   .subscribe(status => {
    //     setTimeout(() => {
    //       this.bookingsStatus = status;
    //     }, 1000);
    //   });
  }
  get isAuthenticated(): boolean {
    return this.authService.isLoggedIn();
  }
  intercomValues() {
    Intercom({
      app_id: this.schoolProps.properties.app_id.toString(),
      region: 'ap',
      apiBase: 'https://api.au.intercom.io',
      name: this.schoolProps.properties.full_name,
      user_id: this.schoolProps.properties.id.toString(),
      user_hash: this.schoolProps.properties.user_hash,
    } as any);
  }
  checkSchoolDropdownActive(url: string) {
    this.activeSchoolDropdown = [
      '/teacher/my-schools',
      '/teacher/find-new-schools',
      '/teacher/my-school-invites'
    ].some(path => url.startsWith(path));
  }

  logout() {
    this.ngxService.start();
    if (localStorage.getItem('bookingSchool') == "true") {
      this.authService.loggedOut();
      if (this.router) {
        this.router.ngOnDestroy();
      }
    } else {
      this.authService.loggedOut();
      if (this.router) {
        this.router.ngOnDestroy();
      }
    }
  }
  navigateToDashboard() {
    this.router.navigate(['/teacher/dashboard']);
  }

  closeOffcanvasOnNav() {
    this.offcanvasOpen = false;
  }
  ngAfterViewInit() {
    Canny('renderChangelog', {
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Teacher
      theme: 'light'
    });
    setTimeout(() => {
      this.sub = this.sharedService.teacher_logo.subscribe((data) => {
        this.schoolLogo = data;
        const userData = JSON.parse(localStorage.getItem("userData") || '{}');
        if (userData && userData.properties) {
          userData.properties.profile_image = data;
          localStorage.setItem("userData", JSON.stringify(userData));
        }
        this.cdRef.detectChanges();
      });
      // Set initial teacherName from localStorage
      this.teacherName = localStorage.getItem('full_name');
      // Subscribe to teacher_name changes for live updates
      this.sharedService.teacher_name?.subscribe((data: string) => {
        this.teacherName = data;
        localStorage.setItem('full_name', data);
        this.cdRef.detectChanges();
      });
      this.bookingsStatus = this.schoolProps.properties.using_cc_to_B;
      // Removed duplicate bookingsStatus$ subscription to avoid multiple updates on reload
    });

  }
  someAsyncCallback() {
    this.ProfileService.bookingsStatus$.subscribe(status => {
      setTimeout(() => {
        this.bookingsStatus = status;
      }, 1000);
      this.cdRef.detectChanges();
    });
  }
  openChangelog() {
    Canny('renderChangelog', {
      labelIds: ['696f1c2b0f343ed4ebeb7351'], // Teacher
      theme: 'light'
    });
  }
  redirectToJobsUrl() {
    if (!this.schoolProps.properties.is_qld_teacher) {
      // Redirect to jobs-test or jobs based on hostname
      if (window.location.hostname === 'booking-test.classcover.com.au') {
        window.open("https://jobs-test.classcover.com.au/", '_blank');
      } else if (window.location.hostname === 'booking.classcover.com.au') {
        window.open("https://jobs.classcover.com.au/", '_blank');
      } else {
        this.router.navigate(['/teacher/jobs']);
      }
    } else {
      this.router.navigate(['/teacher/jobs']);
    }
  }
  redirectToTeacherJobsUrl() {
    // Redirect to jobs-test or jobs based on hostname
    if (window.location.hostname === 'booking-test.classcover.com.au') {
      window.open("https://jobs-test.classcover.com.au/", '_blank');

    } else if (window.location.hostname === 'booking.classcover.com.au') {
      window.open("https://jobs.classcover.com.au/", '_blank');
    } else {
      this.jobsUrl = 'http://localhost:4200/';
    }
  }
  backToAdmin() {
    this.authService.loggedOut();
    // if (this.router) {
    //   this.router.ngOnDestroy();
    // }
    window.open(environment.backToAdmin, '_self');
  }
}
